import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrow-down",
  "use": "svg_arrow-down-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 5\" id=\"svg_arrow-down\"><path fill-rule=\"evenodd\" fill=\"currentColor\" d=\"M4.969 4.956.037-.005h9.925L4.969 4.956z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol